import * as React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const ErrorText = styled.span`
  font-weight: 400;
  line-height: 18px;
  font-size: 14px;
  text-align: center;
  margin-top: 12px;

  color: #00144d;

  span {
    font-weight: bold;
  }
`;

const ErrorPage = () => {
  return (
    <ErrorContainer>
      <ErrorText>
        <span>Something went wrong :(</span>
        <br />
        ...
      </ErrorText>
    </ErrorContainer>
  );
};

export const PaymentErrorPage = () => {
  return (
    <ErrorContainer>
      <ErrorText>
        <span>
          Sorry, we couldn't find this order. <a href="mailto:penn@storewith.co">Contact us</a> and
          we'll get it fixed right away.
        </span>
        <br />
      </ErrorText>
    </ErrorContainer>
  );
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/pages/CustomerPayment/ErrorPage.tsx